import { render, staticRenderFns } from "./QuickLegend.vue?vue&type=template&id=32b20546&scoped=true"
import script from "./QuickLegend.vue?vue&type=script&lang=js"
export * from "./QuickLegend.vue?vue&type=script&lang=js"
import style0 from "./QuickLegend.vue?vue&type=style&index=0&id=32b20546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b20546",
  null
  
)

export default component.exports